export const combineReducers = (key, reducer) => (state, action) => ({
  ...state,
  [key]: { ...reducer(state[key], action) },
});
